import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { DISH_TYPES_QUERY } from '../graphql/queries'
import { COMMON_FETCH_DISH_TYPES } from '../redux/action-types'
import { cleanupCommonFetchCuisineTypes } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useDishTypesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupCommonFetchCuisineTypes)

  const { isLoading, error, data, options } = useSelector(
    store => store.common.dishTypes,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        DISH_TYPES_QUERY,
        {},
        dispatch,
        COMMON_FETCH_DISH_TYPES,
      ),
    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, options }
}

export default useDishTypesQuery
